function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.896 10.91l-1.47-3.433A3.864 3.864 0 018.164 6.2c0-.366.224-.665.499-.665a.5.5 0 00.498-.499c0-.274-.299-.499-.665-.499H5.504c-.366 0-.665.224-.665.5a.5.5 0 00.499.498c.274 0 .498.3.498.665 0 .366-.118.94-.262 1.276l-1.47 3.434c-.145.336-.263.76-.263.943 0 .183.15.483.333.665.183.183.632.333.997.333H8.83c.365 0 .814-.149.997-.333.184-.184.333-.482.333-.665 0-.183-.118-.608-.263-.943v-.001zM7.474 3.554a.474.474 0 10.947 0 .474.474 0 00-.947 0zm-1.275.073a.219.219 0 100-.437.219.219 0 000 .437zm.838-1.094a.693.693 0 100-1.384.693.693 0 000 1.383v.001z",
  fill: "currentColor"
});

var SvgExperimentFlask = function SvgExperimentFlask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgExperimentFlask;